import * as moment from 'moment';

import { Locales } from '../locale/locale-utils';

export function getMomentLocale(locale: string): string {
  switch (locale) {
    case Locales.enGB:
      return 'en-gb';
    case Locales.cyGB:
      return 'cy';
    case Locales.enCA:
      return 'en-ca';
    case Locales.enUS:
      return 'en';
    case Locales.nbNO:
      return 'nb';
    default:
      return 'en-gb';
  }
}

/**
 * Format a date string into a date for display.
 * Returns the given value if date string cannot be parsed.
 *
 * @param {string} date - Date to be formatted
 * @returns {string} - Date in format 'DD/MM/YYYY' (depending on locale), 'MM/YYYY' or 'YYYY'
 */
export function formatDateForDisplay(date: string): string {
  const DATE_FORMAT_FULL = 'L';
  const DATE_FORMAT_MONTH = 'MM/YYYY';
  const DATE_FORMAT_YEAR = 'YYYY';
  const validDateFormats = [
    moment.ISO_8601,
    moment.HTML5_FMT.DATE,
    moment.HTML5_FMT.MONTH,
    DATE_FORMAT_YEAR,
    'D MMM YYYY',
    'D MMMM YYYY',
    'DD MMMM YYYY',
  ];

  const momentDate = moment(date, validDateFormats, true);
  if (!momentDate.isValid()) {
    return date;
  }

  const dateFull = moment(date, moment.HTML5_FMT.DATE, true);
  const dateMonth = moment(date, moment.HTML5_FMT.MONTH, true);
  const dateYear = moment(date, DATE_FORMAT_YEAR, true);

  if (dateFull.isValid()) {
    return dateFull.format(DATE_FORMAT_FULL);
  } else if (dateMonth.isValid()) {
    return dateMonth.format(DATE_FORMAT_MONTH);
  } else if (dateYear.isValid()) {
    return dateYear.format(DATE_FORMAT_YEAR);
  } else {
    return momentDate.format(DATE_FORMAT_FULL);
  }
}

export function ensureDateLocale(localeId: string) {
  const momentLocaleCode = getMomentLocale(localeId);
  moment.locale(momentLocaleCode);
}
